// extracted by mini-css-extract-plugin
export default {"root":"WzbAF8","container":"mpGTIt","listItem":"O6KwRn","link":"oRtuWN","image":"YaS0jR"};